import React, { useState,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
import { API_URL } from "..";
import QuotePreviewLayer from "../components/QuotePreviewLayer";
import ShowReportLayer from "./ShowReportLayer";




const ShowReportPage = () => {
     const {id} = useParams();
     const [data,setData]= useState({})
    
      const fetchSingle = async ()=>{
      //  alert(';Please')
        const user = JSON.parse(localStorage.getItem('user'));
         
       let headersList = {
         "Accept": "*/*",
         "Content-Type": "application/json"
        }
        let response = await fetch(API_URL+`/api/job/fetch-single/${id}`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        
        setData(data.job)
      }
        useEffect(()=>{
          fetchSingle()
          },[2])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="" />

        {/* InvoicePreviewLayer */}
      {
        data?.client_name  === undefined  ? 
        null:
          <ShowReportLayer data={data} />
      }
      

      </MasterLayout>

    </>
  );
};

export default ShowReportPage;
